import React, { useId } from 'react';

import Duration from 'components/Duration';

import type { ConnectionType } from 'store/call/call.state';
import type { InitiationType, TypeMapping } from 'views/Home/Monitoring/types';

import styles from './participant.module.scss';

export type Props = {
    type?: ConnectionType;
    name?: string;
    initiationType?: InitiationType;
    initiationDate?: Date | null;
};

const typeMapping: TypeMapping = {
    AGENT: 'Agent',
    QC_TRANSFER: 'Agent',
    OUTBOUND_TRANSFER: 'Third party',
    CUSTOMER: 'Customer',
    BARGE: 'You',
    MONITOR: 'You',
    UNKNOWN: 'Unknown',
};

const Participant: React.FC<Props> = ({ type = 'UNKNOWN', name, initiationType = 'Unknown', initiationDate }) => {
    const participantHeadingId = useId();

    const formattedType = typeMapping[type];

    return (
        <li className={styles.container} aria-labelledby={participantHeadingId}>
            <div className={styles.containerLeft}>
                <h4 id={participantHeadingId} className={styles.heading}>
                    {formattedType}
                    {name && `: ${name}`}
                </h4>
                {initiationDate !== null && <Duration date={initiationDate} />}
                <p>{initiationType}</p>
            </div>
        </li>
    );
};

export default Participant;
